import { grey } from '@mui/material/colors';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type Props = {
  object: any;
  sx?: SxProps<Theme>;
};

export const JsonBlock = ({ object, sx }: Props) => {
  return (
    <Box
      component='pre'
      bgcolor={grey[100]}
      borderRadius='2px'
      p={3}
      sx={[
        { whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'break-word' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {object && JSON.stringify(object, null, 2)}
    </Box>
  );
};
